export class Message {
  id?: string;
  created?: number;
  content: string;
  sender: string;
  roomId: string;
  // senderId: string;
}
